"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeDateFilterForm = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var GranularityTabs_1 = require("./GranularityTabs");
var RelativeRangePicker_1 = require("../RelativeRangePicker/RelativeRangePicker");
/**
 * @internal
 */
exports.RelativeDateFilterForm = function (_a) {
    var selectedFilterOption = _a.selectedFilterOption, availableGranularities = _a.availableGranularities, onSelectedFilterOptionChange = _a.onSelectedFilterOptionChange, isMobile = _a.isMobile;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GranularityTabs_1.GranularityTabs, { availableGranularities: availableGranularities, selectedGranularity: selectedFilterOption.granularity, onSelectedGranularityChange: function (granularity) {
                return onSelectedFilterOptionChange(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, selectedFilterOption), (selectedFilterOption.granularity !== granularity && {
                    from: undefined,
                    to: undefined,
                })), { granularity: granularity }));
            } }),
        react_1.default.createElement(RelativeRangePicker_1.RelativeRangePicker, { selectedFilterOption: selectedFilterOption, onSelectedFilterOptionChange: onSelectedFilterOptionChange, 
            // Do not reuse components across different tabs, caused problems with focus/blur handling.
            key: selectedFilterOption.granularity, isMobile: isMobile })));
};
//# sourceMappingURL=RelativeDateFilterForm.js.map